import { syncState } from "./types";

export function getDefaultState(): syncState {
    return {
        syncSystem: [],
        syncSystemPageIndex: 1,
        syncSystemPageSize: 30,
        syncSystemsIsBusy: true,
        syncSystemsAtEnd: false,
        syncSystemTemplate: {
            extraValue: "",
            groupId: null,
            host: "",
            password: "",
            port: 0,
            serverTypeId: null,
            syncSystemId: 0,
            title: "",
            username: "",
            syncEntriesCount: 0
        },
        serverTypesCanSync: [],
        // Filtered SyncSystem
        syncSystemFiltered: [],
        syncSystemFilter: "",
        syncSystemFilteredPageIndex: 1,

        /** Site Sync */
        syncEntries: [],
        syncEntryPageIndex: 1,
        syncEntryPageSize: 30,
        syncEntryIsBusy: true,
        requiredSyncEntriesStatusChecked: [],
        syncEntryAtEnd: false,
        siteEntryTemplate: {
            syncSystemTitle: "",
            groupSyncId: 0,
            groupId: null,
            syncSystemId: null,
            identifier: "",
            enabled: false,
            lastUpdated: null,
            syncStarted: null,
            syncTypeId: null,
            dynamicDataTypeId: null
        },
        dynamicDataList: [],
        syncTypes: [],
        userErrorMessage: "",
        // Filtered Sync entries
        syncEntriesFiltered: [],
        syncEntryFilter: "",
        syncEntryFilteredPageIndex: 1,
    }
}